import ApplicationOperationForm from "@/components/field/operations/ApplicationOperationForm";
import PlantingOperationForm from "@/components/field/operations/PlantingOperationForm";
import HarvestOperationForm from "@/components/field/operations/HarvestOperationForm";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Tab, Tabs } from "@heroui/react";
import { createFileRoute, Link, useParams } from "@tanstack/react-router";
import { useState } from "react";
import { Key } from "@react-types/shared";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute(
    "/dashboard/fields/$fieldId/operations/add",
)({
    component: RouteComponent,
});

function RouteComponent() {
    const { fieldId } = useParams({
        from: "/dashboard/fields/$fieldId/operations/add",
    });

    const [type, setType] = useState<Key>("application");
    const { t } = useTranslation("operations");

    return (
        <div className="p-2 flex flex-col gap-2">
            <Button
                size="sm"
                color="primary"
                as={Link}
                to="/dashboard/fields/$fieldId/operations"
                className="mb-2 self-start"
                params={
                    {
                        fieldId,
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } as any
                }
            >
                <FontAwesomeIcon icon={faChevronLeft} /> {t("backToOperations")}
            </Button>
            <Tabs fullWidth selectedKey={type} onSelectionChange={setType}>
                <Tab title="Application" key="application">
                    <ApplicationOperationForm />
                </Tab>
                <Tab title="Planting" key="planting">
                    <PlantingOperationForm />
                </Tab>
                <Tab title="Harvest" key="harvest">
                    <HarvestOperationForm />
                </Tab>
            </Tabs>
        </div>
    );
}
